<template>
  <div id="updateTracking">
    <b-navbar type="light" variant="light-success">
      <b-button v-b-toggle.sidemenu variant="outline-secondary" class="mr-2 d-lg-none"><f-icon icon="bars"></f-icon></b-button>
      <b-navbar-brand  class="mb-0" :to="{ path: '/ld' }" replace>
        <img :src="logoImg" class="d-inline-block align-top" alt="Logo" height="30px">
        {{ logoName }}
      </b-navbar-brand>
    </b-navbar>
    <b-sidebar id="sidemenu" title="Menu" body-class="px-2" shadow>
      <left-menu></left-menu>
    </b-sidebar>
    <b-container fluid class="bg-white shadow-sm">
      <b-row>
        <b-col cols="3" class="d-none d-lg-block pb-4 pt-2">

          <left-menu></left-menu>
        </b-col>
        <b-col lg="9" class="pt-4 pb-4 animate__animated animate__fadeIn">
          <!-- <alert-card></alert-card> -->
          <b-row>
            <b-col>
              <h2>แก้ไขข้อมูลใบสั่งซื้อ</h2>
            </b-col>
            <b-col class="text-right">
              <b-button variant="warning" class="mb-1" @click="$router.push('/User/Tracking')" pill>กลับสู่หน้ารายการ</b-button>
              <b-button variant="success" class="mb-1" @click="onSubmit" pill :disabled="!dataReady">แก้ไขข้อมูลรหัสสินค้า</b-button>
            </b-col>
          </b-row>
          <!-- {{ userType }} -->
          <b-row>
            <b-col cols="12" class="mb-2" v-if="userData.userType === 'U'">
              <!-- <b-card bg-variant="light">
                <b-card-text>
                  {{ 'ชื่อผู้ใช้' }}<br>
                  {{ 'เบอร์โทรผู้ใช้' }} <br>
                  {{ 'ที่อยู่ผู้ใช้' }}
                </b-card-text>
              </b-card> -->
            </b-col>
            <b-col :md="userData.userType === 'A' ? 6 : 12">
              <b-card class="mb-2" title="รายละเอียด">
                <b-card-body class="p-0">
                  <b-card-text>
                    <label for="trackId" class="mb-1">รหัสพัสดุ:</label>
                    <b-form-input id="trackId" class="mb-2" v-model="form.suppliesCode" type="text" ></b-form-input>
                    <template v-if="userData.userType === 'U'">
                      <label for="trackNote" class="mb-1">วลีช่วยจำ:</label>
                      <b-form-input id="trackNote" class="mb-2" v-model="form.mnemonicPhrase" type="text" ></b-form-input>
                    </template>
                  </b-card-text>

                  <b-card-text>
                    <b-form-group label="ประเภทการขนส่ง:" v-slot="{ ariaDescribedby }" class="mb-1">
                      <b-form-radio-group
                        id="transport-type-group"
                        v-model="form.transportType"
                        :aria-describedby="ariaDescribedby"
                        name="transport-radios"
                      >
                        <b-form-radio value="รถ">
                          <f-icon icon="truck"></f-icon> รถ
                        </b-form-radio>
                        <b-form-radio value="เรือ">
                          <f-icon icon="ship"></f-icon> เรือ
                        </b-form-radio>
                      </b-form-radio-group>
                    </b-form-group>
                  </b-card-text>

                  <b-card-text v-if="userData.userType === 'A'">
                    <label for="userCode" class="mb-1">รหัสสมาชิก:</label>
                    <b-form-input id="userCode" class="mb-2" v-model="form.userCode" type="text" placeholder="MP-XXX"></b-form-input>
                    <!-- <label class="mb-1">ประเภทการขนส่ง: {{ form.transportType }}</label> -->

                    <!-- <b-form-input id="trackType" class="mb-2" v-model="form.userId" type="text" ></b-form-input> -->
                    <label for="trackType" class="mb-1">ประเภท:</label>
                    <b-form-input id="trackType" class="mb-2" v-model="form.category" type="text" autocomplete="off" ></b-form-input>
                    <b-row class="mb-2">
                      <b-col>
                        <b-form-checkbox v-model="form.woodenCrate" name="check-wooden" value="เปิดการใช้งาน" unchecked-value="ปิดการใช้งาน" switch>
                          ตีลังไม้
                        </b-form-checkbox>
                      </b-col>
                      <b-col>
                        <b-form-checkbox v-model="form.checkProduct" name="check-product" value="เปิดการใช้งาน" unchecked-value="ปิดการใช้งาน" switch>
                          เช็คสินค้า
                        </b-form-checkbox>
                      </b-col>
                    </b-row>
                    <label for="trackNotice" class="mb-1">หมายเหตุ:</label>
                    <b-form-input id="trackNotice" class="mb-2" v-model="form.remark" type="text" autocomplete="off" ></b-form-input>
                    <!-- <label for="trackLot" class="mb-1">ล๊อต/ลำดับ:</label>
                    <b-form-input id="trackLot" class="mb-2" v-model="form.userId" type="text" ></b-form-input> -->
                  </b-card-text>
                </b-card-body>
              </b-card>
              <b-card title="รายการวันที่" class="mb-2" v-if="userData.userType === 'A'">
                <b-card-body class="p-0">
                  <b-card-text>

                    <label for="InWarehouse" class="mb-1">เข้าโกดัง:</label>
                    <b-form-datepicker id="InWarehouse"
                      reset-button close-button locale="th" placeholder="เลือกวันที่เข้าโกดัง"
                      :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                      class="mb-2" v-model="form.InWarehouse"></b-form-datepicker>

                    <label for="OutWarehouse" class="mb-1">ออกโกดัง:</label>
                    <b-form-datepicker id="OutWarehouse"
                      reset-button close-button locale="th" placeholder="เลือกวันที่ออกโกดัง"
                      :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                      class="mb-2" v-model="form.OutWarehouse"></b-form-datepicker>

                    <label for="InThailand" class="mb-1">ถึงไทย:</label>
                    <b-form-datepicker id="InThailand"
                      reset-button close-button locale="th" placeholder="เลือกวันที่ถึงไทย"
                      :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                      class="mb-2" v-model="form.InThailand"></b-form-datepicker>

                    <label for="Deliver" class="mb-1">ส่งออก:</label>
                    <b-form-datepicker id="Deliver"
                      reset-button close-button locale="th" placeholder="เลือกวันที่ส่งออกพัสดุ"
                      :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                      class="mb-2" v-model="form.deliver"></b-form-datepicker>

                  </b-card-text>
                </b-card-body>
              </b-card>
            </b-col>
            <b-col md="6" v-if="userData.userType === 'A'">
              <b-card title="ขนาด" class="mb-2">
                <b-card-body class="p-0">
                  <b-card-text>
                    <b-row>
                      <b-col>
                        <label for="trackNote" class="mb-1">กว้าง:</label>
                        <b-input-group append="cm" class="mb-2">
                          <b-form-input id="trackNote" v-model="form.wide" type="number" ></b-form-input>
                        </b-input-group>
                      </b-col>
                      <b-col>
                        <label for="orderId" class="mb-1">สูง:</label>
                        <b-input-group append="cm" class="mb-2">
                        <b-form-input id="orderId" v-model="form.high" type="number" ></b-form-input>
                        </b-input-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <label for="trackType" class="mb-1">ยาว:</label>
                        <b-input-group append="cm" class="mb-2">
                        <b-form-input id="trackType"  v-model="form.length" type="number" ></b-form-input>
                        </b-input-group>
                      </b-col>
                      <b-col>
                        <label for="trackId" class="mb-1">น้ำหนัก:</label>
                        <b-input-group append="kg" class="mb-2">
                        <b-form-input id="trackId" v-model="form.weight" type="number"></b-form-input>
                        </b-input-group>
                      </b-col>
                    </b-row>

                    <label for="trackType" class="mb-1">จำนวน:</label>
                    <b-input-group append="ชิ้น" class="mb-2">
                    <b-form-input id="trackType" v-model="form.amount" type="number" ></b-form-input>
                    </b-input-group>
                    <b-row>
                      <b-col>
                        <label for="totalWeight" class="mb-1">น้ำหนักรวม:</label>
                        <b-form-input id="totalWeight" class="mb-2" v-model="form.totalWeight" type="number" ></b-form-input>
                      </b-col>
                      <b-col>
                        <label for="totalQueue" class="mb-1">คิวรวม:</label>
                        <b-form-input id="totalQueue" class="mb-2" v-model="form.totalQueue" type="number" ></b-form-input>
                      </b-col>
                    </b-row>
                  </b-card-text>
                </b-card-body>
              </b-card>

              <b-overlay :show="!dataVipReady">
                <b-card class="mb-2">
                  <b-card-body class="p-0">
                    <b-card-title>
                      ราคา<span v-if="priceCalculate.vipName">ตามระดับ
                        <img :src="picSVG[priceCalculate.vipName]" class="icon-svg"/> {{ priceCalculate.vipName }}
                      </span>
                      <b-dropdown
                        right text="คำนวนราคา" toggle-class="py-1"
                        variant="primary" style="float: right"
                      >
                        <b-dropdown-item href="#" @click="getDataVIP('สินค้าปกติ')">สินค้าปกติ</b-dropdown-item>
                        <b-dropdown-item href="#" @click="getDataVIP('ของเล่น')">มอก,ของเล่น</b-dropdown-item>
                        <b-dropdown-item href="#" @click="getDataVIP('สินค้าอย')">สินค้ามี อย.</b-dropdown-item>
                        <b-dropdown-item href="#" @click="getDataVIP('สินค้าลิขสิทธิ์')">สินค้าลิขสิทธิ์</b-dropdown-item>
                        <b-dropdown-item href="#" @click="getDataVIP('สินค้าควบคุม')">สินค้าควบคุมพิเศษ</b-dropdown-item>
                      </b-dropdown>
                    </b-card-title>
                    <b-card-text>
                      <label for="priceByKilo" class="mb-1">ราคาตามกิโล:</label>
                      <b-input-group append="บาท" class="mb-2">
                      <b-form-input id="priceByKilo" v-model="form.priceByKilo" type="number" ></b-form-input>
                      </b-input-group>
                      <label for="priceByQueue" class="mb-1">ราคาตามคิว:</label>
                      <b-input-group append="บาท" class="mb-2">
                      <b-form-input id="priceByQueue" v-model="form.priceByQueue" type="number" ></b-form-input>
                      </b-input-group>
                      <hr>
                      <label for="other" class="mb-1">อื่นๆ:</label>
                      <b-input-group append="บาท" class="mb-2">
                      <b-form-input id="other" v-model="form.other" type="number" ></b-form-input>
                      </b-input-group>
                    </b-card-text>
                  </b-card-body>
                </b-card>
                <template #overlay>
                  <div class="text-center">
                    <img :src="require('@/assets/svg/thinking.svg')" class="animation-cylon" />
                    <br />
                    <p id="cal-label" class="mt-2">กำลังคำนวนราคา</p>
                  </div>
                </template>
              </b-overlay>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
    <b-container fluid class="text-center mt-3 mb-2">
      {{ footerLC }}
    </b-container>
  </div>
</template>

<script>
import axios from "axios"; // api
import MenuBar from '@/components/Menubar' // เมนู
// import AlertCard from '@/components/Alert' // แจ้งเดือน
export default {
  name: "UpdateTracking",
  components: {
    'left-menu': MenuBar,
    // 'alert-card': AlertCard
  },
  beforeCreate() {
    // เหตุการจะเกิดขึ้นก่อนที่ Component จะถูก render เข้าไปใน DOM
    // this.$liff.init({ liffId: this.$liff_register_profile }, function (data) {})
  },
  created() {
    // ทุกอย่างจะถูกเตรียมไว้ครบหมดแล้ว และสามารถเข้าถึงได้หมด
    // setInterval(this.getDataMap, 1000)
  },
  async mounted() {
    // จะเกิดขึ้นเมื่อ DOM ถูกสร้างเสร็จแล้ว เราสามารถ เข้าถึง Element ต่างๆใน DOM ได้ทั้งหมด
    // เช่นการ ดึงข้อมูลจาก input เป็นต้น
    this.getDataUser()
    await this.getDataTracking(this.$route.query.suppliesCode)

    this.priceCalculate = this.priceByQueueOrKilo
  },
  data() {
    return {
      userType: '',
      userData: {
        userName: '',
        firstName: '',
        lastName: '',
        telephoneNumber: '',
        userType: ''
      },
      priceCalculate: {},
      form: {
        userCode: '',
        userName: '',
        suppliesCode: '',
        orderList: '',
        mnemonicPhrase: '',
        category: '',
        transportType: 'รถ', //รถเท่านั้น
        woodenCrate: 'ปิดการใช้งาน',
        checkProduct: 'ปิดการใช้งาน',
        remark: '',

        amount: '',
        weight: '',

        wide: '',
        high: '',
        length: '',

        totalWeight: '',
        totalQueue: '',

        InWarehouse: '',
        OutWarehouse: '',
        InThailand: '',
        deliver: '',

        priceByKilo: '',
        priceByQueue: '',
        other: '',
        LAST_USER: ''
      },
      dataReady: true,
      dataVipReady: true,
    };
  },
  methods: {
    onSubmit() {
      // console.log(this.form)
      this.dataReady = false
      this.form.LAST_USER = this.userData.userName
      axios
        .post(
          // eslint-disable-next-line quotes
          "https://licm-cargo.com/api/Invoice_order/Invoice_update",
          this.form,
          {
            headers: this.getHeaderAPI('Invoice_update', this.form.userName)
          }
        )
        .then(async (response) => {
          console.log('onSubmit', response)
          let rs = response.data
          if (rs.status === true) {
            this.$swal("สำเร็จ","แก้ไขข้อมูลพัสดุเรียบร้อย","success")
              .then((result) => {
                this.$router.push('/User/Tracking')
              })
          } else {
            console.log('registerUser Fail')
            this.$swal("ผิดพลาด","ไม่สามารถแก้ไขข้อมูลพัสดุได้","error")
            this.dataReady = true
          }
          this.dataReady = true
        })
        .catch((error) => {
          console.log(error.response)
          // this.$swal("ผิดพลาด","ไม่สามารถแก้ไขข้อมูลพัสดุได้ ","error")
          if (error.response.data.message) {
            this.$swal("ผิดพลาด", error.response.data.message, "error");
          } else {
            this.$swal("ผิดพลาด", "ไม่สามารถแก้ไขข้อมูลพัสดุได้", "error");
          }
          this.dataReady = true
        })
    },
    // async onSelectPrice (typeName) {
    //   if (this.form.userCode) {
    //     await this.getDataVIP(this.form.userCode)

    //     if (this.form.totalWeight && this.form.totalQueue) {
    //       let ratePriceWeight = this.priceCalculate.generalKilo
    //       let ratePriceQueue = this.priceCalculate.generalQueue
    //       if (typeName === 'ของเล่น') {
    //         ratePriceWeight = this.priceCalculate.tisKilo
    //         ratePriceQueue = this.priceCalculate.tisQueue
    //       }
    //       if (typeName === 'สินค้าอย') {
    //         ratePriceWeight = this.priceCalculate.fdaKilo
    //         ratePriceQueue = this.priceCalculate.fdaQueue
    //       }
    //       if (typeName === 'สินค้าลิขสิทธิ์') {
    //         ratePriceWeight = this.priceCalculate.copyrightKilo
    //         ratePriceQueue = this.priceCalculate.copyrightQueue
    //       }
    //       if (typeName === 'สินค้าควบคุม') {
    //         ratePriceWeight = this.priceCalculate.specialControlKilo
    //         ratePriceQueue = this.priceCalculate.specialControlQueue
    //       }

    //       let priceW = this.form.totalWeight * ratePriceWeight
    //       let priceQ = this.form.totalQueue * ratePriceQueue

    //       console.log('ราคาเรท', priceW, priceQ)

    //       if (priceW > priceQ){
    //         this.form.priceByKilo = priceW.toFixed(2)
    //         this.form.priceByQueue = ''
    //       } else {
    //         this.form.priceByKilo = ''
    //         this.form.priceByQueue = priceQ.toFixed(2)
    //       }
    //     } else {
    //       this.$swal("ผิดพลาด", "กรุณาระบุน้ำหนักรวมและคิวรวมเพื่อคำนวน", "warning")
    //     }
    //   } else {
    //     this.$swal("ผิดพลาด", "กรุณาระบุรหัสสมาชิกเพื่อคำนวน", "warning")
    //     return;
    //   }
    // },
    getDataUser () {
      this.dataReady = false;
      let lsUser = this.getDataStorageUser()
      if (lsUser) {
        this.userData = lsUser
        // this.form.userName = lsUser.userName
      } else {
        this.$router.push('/Login')
      }
    },
    getDataTracking (dt) {
      this.dataReady = false;
      axios
        .get(
          // eslint-disable-next-line quotes
          'https://licm-cargo.com/api/Invoice_order/Invoice_list_update?suppliesCode=' +
          // '&userType=' +
          // this.userData.userName +
          // this.userData.userType +
          // '&suppliesCode=' +
          dt,
          {
            headers: this.getHeaderAPI('Invoice_list_update', dt)
          }
        )
        .then((response) => {
          console.log('getDataTracking', response.data)

          let rs = response.data
          if (rs.status === true){
            this.form = rs.data
            // this.getUserProfile(this.form.userName)
          } else {
            this.$swal("ผิดพลาด","ไม่สามารถดึงรหัสพัสดุได้","error")
          }

          this.dataReady = true
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('getDataTracking error:', error)
          this.dataReady = true;
        });
    },
    getDataVIP (typeName) {
      this.dataReady = false;
      this.dataVipReady = false;
      if (this.form.userCode) {
        axios
          .get(
            // eslint-disable-next-line quotes
            'https://licm-cargo.com/api/Vip/Vip_user?userCode=' +
            this.form.userCode,
            {
              // headers: this.getHeaderAPI('Vip_user', this.form.userCode)
              headers: { 'application-key' : 'T2FLZ#Xo:!WJ%qnC+jPf(U&EkHDi_K8V*S(QKb)!Rcqd6XI8pOyl_unZWN2PS,E*1r=f*eL7E:4%;6y@I.)$!P_xHCnh,q3AKU#tap' }
            }
          )
          .then((response) => {
            console.log('getDataVIP', response.data)

            let rs = response.data
            if (rs.status === true){
              this.priceCalculate = rs.data
            }

            this.onSelectPrice(typeName)

            this.dataReady = true
            this.dataVipReady = true
          })
          // eslint-disable-next-line handle-callback-err
          .catch((error) => {
            this.$swal("ผิดพลาด", "getDataVIP error", "error")
            console.log('getDataVIP error:', error)
            this.dataReady = true
            this.dataVipReady = true
          });
      } else {
        this.$swal("ผิดพลาด", "กรุณาระบุรหัสสมาชิกเพื่อคำนวน", "warning")
        return;
      }
    },
    onSelectPrice (typeName) {
      // if (this.form.userCode) {
      // await this.getDataVIP(this.form.userCode)
      if (this.form.totalWeight && this.form.totalQueue) {
        let ratePriceWeight = this.priceCalculate.generalKilo
        let ratePriceQueue = this.priceCalculate.generalQueue
        if (typeName === 'ของเล่น') {
          ratePriceWeight = this.priceCalculate.tisKilo
          ratePriceQueue = this.priceCalculate.tisQueue
        }
        if (typeName === 'สินค้าอย') {
          ratePriceWeight = this.priceCalculate.fdaKilo
          ratePriceQueue = this.priceCalculate.fdaQueue
        }
        if (typeName === 'สินค้าลิขสิทธิ์') {
          ratePriceWeight = this.priceCalculate.copyrightKilo
          ratePriceQueue = this.priceCalculate.copyrightQueue
        }
        if (typeName === 'สินค้าควบคุม') {
          ratePriceWeight = this.priceCalculate.specialControlKilo
          ratePriceQueue = this.priceCalculate.specialControlQueue
        }

        let priceW = this.form.totalWeight * ratePriceWeight
        let priceQ = this.form.totalQueue * ratePriceQueue

        console.log('ราคาเรท', priceW, priceQ)

        if (priceW > priceQ){
          this.form.priceByKilo = priceW.toFixed(2)
          this.form.priceByQueue = ''
        } else {
          this.form.priceByKilo = ''
          this.form.priceByQueue = priceQ.toFixed(2)
        }
      } else {
        this.$swal("ผิดพลาด", "กรุณาระบุน้ำหนักรวมและคิวรวมเพื่อคำนวน", "warning")
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#form-profile {
  text-align: left;
}

div.language-bar {
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/User/UpdateTracking.vue